import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import { SAFETY_NOTICE_TEXT } from './Availability/disclaimerConfig';

function SafetyNoticeDialog({ open, onOk }) {
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      onClose={() => {}}
      disableEscapeKeyDown
    >
      <DialogTitle>Safety &amp; Compliance Notice</DialogTitle>
      <DialogContent>
        <DialogContentText style={{ whiteSpace: 'pre-line' }}>
          {SAFETY_NOTICE_TEXT}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={onOk}
          style={{ backgroundColor: '#3B5BDB', color: '#fff' }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SafetyNoticeDialog;
